<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [customBack]="customBackRoute"
    [title]="'Job Requests'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <ng-container *ngIf="isLimitedAccount && loaded">

      <tidy-alert *ngIf="delegationRequests?.length == 0">
        <tidy-text
          [body]="'No requests'">
        </tidy-text>
      </tidy-alert>

      <tidy-card *ngFor="let delegation of delegationRequests">
        <tidy-card-button (action)="goToDelegationRequest(delegation)">
          <tidy-row class="vertical-align-center">
            <tidy-image
               [src]="'assets/svg/alert-circle.svg'"
               class="header-size">
             </tidy-image>
            <tidy-text
              [header]="delegation.delegated_by_team_member.homekeeper.name.substr(0,delegation.delegated_by_team_member.homekeeper.name.indexOf(' ')) + ' asked you to accept a job'"
              [translate]="false">
            </tidy-text>
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Any questions? Contact '">
            </tidy-text>
            <tidy-text
              [body]="delegation.delegated_by_team_member.homekeeper.name.substr(0,delegation.delegated_by_team_member.homekeeper.name.indexOf(' ')) + '.'"
              [translate]="false">
            </tidy-text>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>

    </ng-container>

    <ng-container *ngIf="!isLimitedAccount">

      <div class="daterange-custom-container" *ngIf="currentWeek?.days?.length > 0 || startDate !== ''">
        <tidy-daterange
          class="daterange-custom-input"
          [label]="'Date Range'"
          (customDateOption)="selectCustomDateRange($event)"
          (stringDateOption)="selectStringDateRange($event)"
          [(dateRangeForm)]="dateRangeForm"
          [selectOptions]="selectOptions"
          [rangeOption]="rangeOption"
          [appearance]="'outline'">
        </tidy-daterange>
      </div>

      <ng-container *ngIf="loaded">

        <tidy-error-message
          *ngIf="errorMessage && !isTimeOut"
          [text]="errorMessage">
        </tidy-error-message>

        <ng-container *ngIf="errorMessage && isTimeOut">
          <tidy-text
            [body]="'It looks like you aren’t connected to the internet. '">
          </tidy-text>
          <tidy-text
            [body]="'Try Again'"
            (action)="getInitialData()"
            class="link">
          </tidy-text>
        </ng-container>

        <ng-container *ngIf="!didGoLive && hasNoExampleCoops && currentWeek?.days?.length === 0 && clientRequests?.length === 0 && delegationRequests?.length === 0">
          <tidy-alert *ngIf="addedZipcode">
            <tidy-row>
              <tidy-text
                [body]="'There are no job requests within your max drive time at your current rates right now. Check back later and consider '">
              </tidy-text>
              <tidy-text
                (action)="goToDriveTime()"
                [body]="'increasing your max drive time'"
                class="link">
              </tidy-text>
              <tidy-text
                [body]="' or '">
              </tidy-text>
              <tidy-text
                (action)="goToRates()"
                [body]="'making sure your rates are competitive'"
                class="link">
              </tidy-text>
              <tidy-text
                [body]="'.'">
              </tidy-text>
            </tidy-row>
          </tidy-alert>
          <tidy-alert *ngIf="!addedZipcode">
            <tidy-row>
              <tidy-text
                [body]="'Add account info to see Clients near you! '">
              </tidy-text>
              <tidy-text
                (action)="addAccountInfo()"
                [body]="'Add Account Info'"
                class="link">
              </tidy-text>
            </tidy-row>
          </tidy-alert>
        </ng-container>

        <tidy-alert *ngIf="didGoLive && currentWeek?.days?.length === 0 && clientRequests?.length === 0 && delegationRequests?.length === 0">
          <tidy-row *ngIf="dateRangeForm.value.customStringSelect == 'all_time'">
            <tidy-text
              [body]="'There are no client requests within your max drive time at your current rates right now. Check back later and consider '">
            </tidy-text>
            <tidy-text
              (action)="goToDriveTime()"
              [body]="'increasing your max drive time'"
              class="link">
            </tidy-text>
            <tidy-text
              [body]="' or '">
            </tidy-text>
            <tidy-text
              (action)="goToRates()"
              [body]="'making sure your rates are competitive'"
              class="link">
            </tidy-text>
            <tidy-text
              [body]="'.'">
            </tidy-text>
          </tidy-row>
          <tidy-row *ngIf="dateRangeForm.value.customStringSelect !== 'all_time'">
            <tidy-text
              [body]="'No results for this time range at your current rates right now. Check back later and consider '">
            </tidy-text>
            <tidy-text
              (action)="goToDriveTime()"
              [body]="'increasing your max drive time'"
              class="link">
            </tidy-text>
            <tidy-text
              [body]="' or '">
            </tidy-text>
            <tidy-text
              (action)="goToRates()"
              [body]="'making sure your rates are competitive'"
              class="link">
            </tidy-text>
            <tidy-text
              [body]="'.'">
            </tidy-text>
          </tidy-row>
        </tidy-alert>

        <tidy-card *ngFor="let delegation of delegationRequests">
          <tidy-card-button (action)="goToDelegationRequest(delegation)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                 [src]="'assets/svg/alert-circle.svg'"
                 class="header-size">
               </tidy-image>
              <tidy-text
                [header]="delegation.delegated_by_team_member.homekeeper.name.substr(0,delegation.delegated_by_team_member.homekeeper.name.indexOf(' '))"
                [translate]="false">
              </tidy-text>
              <tidy-text
                [header]="' asked you to accept a job'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Any questions? Contact '">
              </tidy-text>
              <tidy-text
                [body]="delegation.delegated_by_team_member.homekeeper.name.substr(0,delegation.delegated_by_team_member.homekeeper.name.indexOf(' ')) + '.'"
                [translate]="false">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>

        <ng-container *ngFor="let request of clientRequests">
          <tidy-card *ngIf="request?.initiated_by === 'customer'">
            <tidy-row class="vertical-align-center">
             <tidy-image
                [src]="'assets/svg/person.svg'"
                class="header-size white-icon">
              </tidy-image>
              <tidy-text
                [header]="(request?.address?.customer?.account_name !== '' && request?.address?.customer?.account_name ? request?.address?.customer?.account_name : (request?.address?.customer?.first_name + ' ' + request?.address?.customer?.last_name)) + ' Requests You'"
                [translate]="false">
              </tidy-text>
            </tidy-row>
            <ng-container *ngIf="request?.address?.customer?.is_private">
              <tidy-row *ngIf="request?.address?.address1">
                <tidy-text
                  [body]="request?.address?.address1 + (request?.address?.address2 ? (' ' + request?.address?.address2) : '') + (request?.address_name ? (' - ' + request?.address_name) : '')"
                  [translate]="false">
                </tidy-text>
              </tidy-row>
            </ng-container>
            <tidy-row *ngIf="request?.address | tidyPropertyDetails as propertyDetails">
              <tidy-text [body]="propertyDetails"></tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="(request?.service_type_details?.customer_name +
                ' ' +
                (request?.frequency | planFrequency)) | titlecase">
              </tidy-text>
            </tidy-row>
            <tidy-row class="extra-bottom-padding" *ngIf="request?.homekeeper_rate">
              <tidy-text
                [body]="(request?.homekeeper_rate | tcurrency) + ' Total'">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngFor="let day of request?.request_times">
              <tidy-text
                [body]="day[0].date | formatDateTimePipe: 'LLL d'">
              </tidy-text>
              <tidy-text
                [body]="': '">
              </tidy-text>
              <ng-container *ngFor="let time of day; let last = last">
                <tidy-text
                  [body]="time?.time | ttime">
                </tidy-text>
                <tidy-text *ngIf="!last"
                  [body]="', '">
                </tidy-text>
              </ng-container>
            </tidy-row>
            <tidy-row class="extra-top-padding">
              <tidy-button
                [action]="navigateToAcceptRequest.bind(this, request)"
                [text]="'Accept One of These Times'"
                class="primary">
              </tidy-button>
            </tidy-row>
            <tidy-row>
              <tidy-button
                [action]="navigateToProposeAlternateRequest.bind(this, request)"
                [text]="'Propose Alternate Times'"
                class="secondary">
              </tidy-button>
            </tidy-row>
            <tidy-row>
              <tidy-button
                [action]="declineRequest.bind(this, request)"
                [text]="'Decline Request'"
                class="secondary">
              </tidy-button>
            </tidy-row>
            <ng-container *ngIf="request?.bookingFormAnswers?.length > 0">
              <tidy-row class="extra-top-padding extra-bottom-padding">
                <tidy-divider>
                </tidy-divider>
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-image
                  [src]="'assets/img/information.svg'"
                  class="header-size">
                </tidy-image>
                <tidy-text
                  [header]="'Job Note'">
                </tidy-text>
              </tidy-row>
              <ng-container *ngFor="let answer of request?.bookingFormAnswers">
                <ng-container *ngIf="answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area'">
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + answer?.data?.value">
                    </tidy-text>
                  </tidy-row>
                  <tidy-photo-note
                    *ngIf="answer?.template_input?.image_url"
                    [src]="answer?.template_input?.image_url">
                  </tidy-photo-note>
                </ng-container>
                <ng-container *ngIf="answer?.template_input?.type == 'select'">
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)">
                    </tidy-text>
                  </tidy-row>
                  <tidy-photo-note
                    *ngIf="answer?.template_input?.image_url"
                    [src]="answer?.template_input?.image_url">
                  </tidy-photo-note>
                </ng-container>
                <ng-container *ngIf="answer?.template_input?.type == 'multiselect'">
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)">
                    </tidy-text>
                  </tidy-row>
                  <tidy-photo-note
                    *ngIf="answer?.template_input?.image_url"
                    [src]="answer?.template_input?.image_url">
                  </tidy-photo-note>
                </ng-container>
                <ng-container *ngIf="answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image'">
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label">
                    </tidy-text>
                  </tidy-row>
                  <tidy-carrousel
                    class="photo-notes-carrousel only-padding-bottom"
                    [scaleImages]="true">
                    <tidy-photo-note
                      *tidyCarrousel
                      [src]="answer?.data?.value">
                    </tidy-photo-note>
                  </tidy-carrousel>
                </ng-container>
                <ng-container *ngIf="answer?.template_input?.type == 'files'  && answer?.template_input?.data?.type == 'images'">
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label">
                    </tidy-text>
                  </tidy-row>
                  <tidy-carrousel
                    class="photo-notes-carrousel only-padding-bottom"
                    [scaleImages]="true">
                    <ng-container *ngFor="let imageUrl of answer?.data?.value">
                      <tidy-photo-note
                        *tidyCarrousel
                        [src]="imageUrl">
                      </tidy-photo-note>
                    </ng-container>
                  </tidy-carrousel>
                </ng-container>
              </ng-container>
            </ng-container>
          </tidy-card>

          <tidy-card *ngIf="request?.initiated_by === 'homekeeper'">
            <tidy-row class="vertical-align-center">
             <tidy-image
                [src]="'assets/svg/person.svg'"
                class="header-size white-icon">
              </tidy-image>
              <tidy-text
                [header]="'You Proposed Alternate Times'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="(request?.service_type_details?.name | titlecase) +
                ' ' +
                (request.frequency | planFrequency)">
              </tidy-text>
              <tidy-text
                [body]="' request from '">
              </tidy-text>
              <tidy-text
                [body]="request?.address?.customer?.account_name && request?.address?.customer?.account_name !== '' ? request?.address?.customer?.account_name : request?.address?.customer?.first_name"
                [translate]="false">
              </tidy-text>
            </tidy-row>
            <tidy-row *ngFor="let day of request?.request_times">
              <tidy-text
                [body]="day[0].date | formatDateTimePipe: 'LLL d'">
              </tidy-text>
              <tidy-text
                [body]="': '">
              </tidy-text>
              <ng-container *ngFor="let time of day; let last = last">
                <tidy-text
                  [body]="time?.time | ttime">
                </tidy-text>
                <tidy-text *ngIf="!last"
                  [body]="', '">
                </tidy-text>
              </ng-container>
            </tidy-row>
            <tidy-row class="extra-top-padding">
              <tidy-button
                [action]="cancelCounterRequest.bind(this, request)"
                [text]="'Cancel Proposed Times'"
                class="secondary">
              </tidy-button>
            </tidy-row>
          </tidy-card>
        </ng-container>

        <tidy-card *ngFor="let day of currentWeek?.days; let i = index">
          <tidy-row [alignLastItemRight]="true" [ngClass]="!day?.showMap ? '' : 'extra-bottom-padding'">
            <tidy-image
              src="assets/style-guide-images/bowtie-white.svg"
              class="header-size">
            </tidy-image>
            <ng-container *ngIf="today === day.formatedDate">
              <tidy-text
                [header]="'Today,'">
              </tidy-text><span>&nbsp;</span>
              <tidy-text
                [header]="(day.date | formatDateTimePipe:'EEEE LLL d')">
              </tidy-text>
            </ng-container>
            <tidy-text
              *ngIf="today !== day.formatedDate"
              [header]="day.dateLabel">
            </tidy-text>
            <tidy-text
              *ngIf="!day?.showMap"
              [body]="'Show Map'"
              (action)="setMap(day, i)"
              class="link">
            </tidy-text>
            <tidy-text
              *ngIf="day?.showMap === true"
              [body]="'Hide Map'"
              (action)="day.showMap = false"
              class="link">
            </tidy-text>
          </tidy-row>
          <tidy-row class="flex extra-bottom-padding" *ngIf="legends && legends[i]?.length > 0">
            <tidy-text
              [body]="'You have jobs at'">
            </tidy-text>
            <span class="map-marker-date" *ngFor="let cleaningTime of legends[i]">
              {{cleaningTime | ttime}}
            </span>
          </tidy-row>
          <tidy-row>
            <div id="map{{i}}" [attr.id]="'map' + i"  style="width: 100%; border-radius: 6px;" [ngStyle]="day?.showMap === true ?{'height': '300px'} : {'height': '0px'}">
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-text
              *ngIf="day?.cleanings.length > 1"
              [body]="'These Clients need you, tap a job to view:'">
            </tidy-text>
            <tidy-text
              *ngIf="day?.cleanings.length === 1"
              [body]="'This Client needs you, tap to view:'">
            </tidy-text>
          </tidy-row>
          <ng-container *ngFor="let cleaning of day?.filteredCleanings; let i = index">
            <tidy-card-button (action)="navigateToCleaning(cleaning)">
              <tidy-grid>
                <ion-row>
                  <ion-col size="2" *ngIf="day?.showMap === true">
                    <tidy-marker [letter]="i"></tidy-marker>
                  </ion-col>
                  <ion-col>
                    <tidy-row class="vertical-align-center">
                      <tidy-text
                        [header]="cleaning.customer_first_name"
                        [translate]="false">
                      </tidy-text>
                      <tidy-image
                        *ngIf="cleaning?.is_private || cleaning?.is_repeat"
                        [src]="'assets/img/star.svg'"
                        class="header-size"
                        style="margin-left:5px">
                      </tidy-image>
                    </tidy-row>
                    <tidy-row>
                      <tidy-text
                        *ngIf="!cleaning?.lastTimeThatDay"
                        [body]="'Starts '">
                      </tidy-text>
                      <tidy-text
                        *ngIf="!cleaning?.lastTimeThatDay"
                        [body]="(cleaning?.time | ttime)">
                      </tidy-text>
                      <tidy-text
                        *ngIf="cleaning?.lastTimeThatDay"
                        [body]="'Flexible start '">
                      </tidy-text>
                      <tidy-text
                        *ngIf="cleaning?.lastTimeThatDay"
                        [body]="(cleaning?.time | ttime) + ' - ' + (cleaning?.lastTimeThatDay | ttime)">
                      </tidy-text>
                    </tidy-row>
                    <tidy-row *ngIf="!(cleaning?.address && cleaning?.is_private)">
                      <ng-container *ngIf="cleaning?.service_type_details?.name && cleaning?.service_type_details?.key && !cleaning?.service_type_details?.key?.includes('cleaning')">
                        <tidy-text
                          [body]="cleaning?.service_type_details?.name">
                        </tidy-text>
                      </ng-container>
                      <ng-container *ngIf="cleaning.service_type_details.key.includes('cleaning')">
                        <tidy-text
                          [body]="parseServiceLength(cleaning.service_type) | titlecase">
                        </tidy-text>
                        <tidy-text
                          [body]="' Regular Cleaning '">
                        </tidy-text>
                      </ng-container>
                    </tidy-row>
                    <ng-container *ngIf="cleaning?.address && cleaning?.is_private">
                      <tidy-row>
                        <tidy-text
                          [body]="cleaning?.service_type_details?.customer_name">
                        </tidy-text>
                      </tidy-row>
                      <tidy-row>
                        <tidy-text
                          [body]="cleaning?.address?.address1 + (cleaning?.address?.address2 ? (' ' + cleaning?.address?.address2) : '') + (cleaning?.address_name ? (' - ' + cleaning?.address_name) : '')"
                          [translate]="false">
                        </tidy-text>
                      </tidy-row>
                    </ng-container>
                    <tidy-row *ngIf="cleaning?.address | tidyPropertyDetails as propertyDetails">
                      <tidy-text [body]="propertyDetails"></tidy-text>
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-grid>
              <tidy-grid style="margin-top:5px">
                <ion-row>
                  <ion-col size="2" *ngIf="day?.showMap === true">
                  </ion-col>
                  <ion-col>
                    <tidy-row>
                      <payment-tag
                        [billingType]="cleaning.billing_type"
                        [totalValue]="cleaning.cleaning_amount"
                        [bonusValue]="cleaning.bonus_amount">
                      </payment-tag>
                      <tidy-text
                        *ngIf="cleaning.type == 'plan'"
                        [body]="' / ' + (cleaning?.frequency | planFrequency)"
                        style="margin-right:10px; margin-left: 5px">
                      </tidy-text>
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-grid>
              <tidy-grid style="margin-top:5px" *ngIf="cleaning?.credential_requirements?.mandatory_requirements_satisfied === false">
                <ion-row>
                  <ion-col size="2" *ngIf="day?.showMap === true">
                  </ion-col>
                  <ion-col>
                    <tidy-row>
                      <span class="credential-badge credential-badge-needed">Credentials needed</span>
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-grid>
              <tidy-grid style="margin-top:5px" *ngIf="checkShouldShowBigSpender(cleaning)">
                <ion-row>
                  <ion-col size="2">
                  </ion-col>
                  <ion-col>
                    <tidy-row>
                      <tidy-text
                        [actionBody]="'Big Spender: They book many jobs.'"
                        class="green">
                      </tidy-text>
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-grid>
              <tidy-grid style="margin-top:5px" *ngIf="(cleaning?.homekeeper_preferences?.gender == 'female' ||  cleaning?.homekeeper_preferences?.gender == 'male') && hasTeamMembers">
                <ion-row>
                  <ion-col size="2" *ngIf="day?.showMap === true">
                  </ion-col>
                  <ion-col>
                    <tidy-row>
                      <tidy-text
                        [body]="cleaning?.homekeeper_preferences?.gender == 'female' ? 'Females Only' : 'Males Only'">
                      </tidy-text>
                    </tidy-row>
                  </ion-col>
                </ion-row>
              </tidy-grid>
              <tidy-row *ngIf="shouldShowQuoteForCleaning(cleaning, day, i)" style="margin-top: 10px;">
                <tidy-alert class="info-quote-alert">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/svg/information-circle-outline.svg'"
                      class="body-size"
                      style="margin-right: 8px;">
                    </tidy-image>
                    <tidy-text [body]="formatQuoteIndicator(getAllQuotesForJob(cleaning))" [translate]="false" style="font-weight: 600;"></tidy-text>
                  </tidy-row>
                </tidy-alert>
              </tidy-row>
            </tidy-card-button>
          </ng-container>
        </tidy-card>

        <ng-container *ngIf="didGoLive || currentWeek?.days?.length > 0">
          <ion-infinite-scroll (ionInfinite)="loadMoreEmergencyCleanings($event)" *ngIf="!isLoadingMoreJobs">
            <ion-infinite-scroll-content
              loadingSpinner="bubbles">
            </ion-infinite-scroll-content>
          </ion-infinite-scroll>
          <!-- Show loading indicator when retriggering infinite scroll -->
          <ng-container *ngIf="isLoadingMoreJobs">
            <div style="display: flex; justify-content: center; align-items: center; margin-top: 15px">
              <ion-spinner name="bubbles"></ion-spinner>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!didGoLive && currentWeek?.days?.length === 0">
          <ng-container *ngFor="let day of examples; let i = index">
            <tidy-card *ngIf="day?.examples?.length > 0">
              <tidy-row [alignLastItemRight]="true">
                <tidy-image
                  src="assets/style-guide-images/bowtie-white.svg"
                  class="header-size">
                </tidy-image>
                <tidy-text
                  [header]="day.day | formatDateTimePipe:'EEEE LLL d'">
                </tidy-text>
                <tidy-text
                  *ngIf="!day?.showMap"
                  [body]="'Show Map'"
                  (action)="setExamplesMap(day, i)"
                  class="link">
                </tidy-text>
                <tidy-text
                  *ngIf="day.showMap"
                  [body]="'Hide Map'"
                  (action)="hideExampleMap(i)"
                  class="link">
                </tidy-text>
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <div id="map{{i}}" [attr.id]="'map' + i"  style="width: 100%; border-radius: 6px;" [ngStyle]="day?.showMap === true ?{'height': '300px'} : {'height': '0px'}">
                </div>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  *ngIf="day?.examples.length > 1"
                  [body]="'These Clients need you, tap a job to view:'">
                </tidy-text>
                <tidy-text
                  *ngIf="day?.examples.length === 1"
                  [body]="'This Client needs you, tap to view:'">
                </tidy-text>
              </tidy-row>
              <ng-container *ngFor="let example of day?.examples; let i = index">
                <tidy-card-button (action)="showExampleRequestAlert()">
                  <tidy-grid>
                    <ion-row>
                      <ion-col size="2">
                        <tidy-marker [letter]="i"></tidy-marker>
                      </ion-col>
                      <ion-col size="4">
                        <tidy-text
                          [body]="example.time | ttime">
                        </tidy-text><br>
                        <tidy-text
                          [body]="(example.duration_in_minutes / 60) + ' hours'">
                        </tidy-text>
                      </ion-col>
                      <ion-col size="6" >
                        <tidy-text
                          [body]="'Earn '">
                        </tidy-text>
                        <tidy-text
                          [body]="(example.base_rate + example.avg_bonus_amount*.8  | tcurrencyRound)">
                        </tidy-text>
                      </ion-col>
                    </ion-row>
                  </tidy-grid>
                </tidy-card-button>
              </ng-container>
            </tidy-card>
          </ng-container>
          <tidy-alert *ngIf="!hasNoExampleCoops">
            <tidy-row>
              <tidy-text
                [body]="'*Until you complete all steps to get client requests, data on this page is estimated based on recent requests. We cannot determine the exact available leads until you have all your booking constraints and data.'">
              </tidy-text>
            </tidy-row>
          </tidy-alert>
        </ng-container>

      </ng-container>

    </ng-container>

    <ng-container *ngIf="!loaded">
      <tidy-card>
        <tidy-row>
          <ion-skeleton-text animated style="width: 100%; height: 300px"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 85%"></ion-skeleton-text>
        </tidy-row>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
      </tidy-card>
      <tidy-card>
        <tidy-row>
          <ion-skeleton-text animated style="width: 100%; height: 300px"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 85%"></ion-skeleton-text>
        </tidy-row>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
      </tidy-card>
      <tidy-card>
        <tidy-row>
          <ion-skeleton-text animated style="width: 100%; height: 300px"></ion-skeleton-text>
        </tidy-row>
        <tidy-row>
          <ion-skeleton-text animated style="width: 85%"></ion-skeleton-text>
        </tidy-row>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
        <tidy-card-button [hideArrow]="true">
          <tidy-grid>
            <ion-row>
              <ion-col size="2">
                <ion-skeleton-text animated style="width: 80%; height: 25px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="4">
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 52%"></ion-skeleton-text>
              </ion-col>
              <ion-col size="6">
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-card-button>
      </tidy-card>
    </ng-container>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
